import { createContext, useContext } from 'react';
import type { RealtimeService } from './RealtimeService';

/** Internal context. It is intentionally not re-exported from the realtime public barrel. */
export const RealtimeServiceContext = createContext<RealtimeService | null>(null);

export function useRealtimeServiceInternal(): RealtimeService {
  const service = useContext(RealtimeServiceContext);
  if (!service) throw new Error('Realtime hooks must be used within a RealtimeProvider');
  return service;
}
